import classNames from 'classnames'

interface SelectInput2ClassnamesProps {
  classes: string
  value: string | string[] | readonly string[] | number
  multiple: boolean
  fullWidth: boolean
  error: boolean | string | string[] | readonly string[]
  padding: string
}

export const generateSelectClassnames = (
  props: SelectInput2ClassnamesProps
) => {
  const { classes, value, multiple, fullWidth, error, padding } = props

  return classNames(classes, {
    // Base styles
    'bg-white border border-gray-50 appearance-none placeholder-text-secondary placeholder-tracking-[0.2px] leading-[24px] font-normal font-sansPro rounded-[4px]':
      true,
    'text-default': value,
    'text-secondary': value !== '',
    // Transitions
    'transition-colors transition-shadow duration-300': true,
    // Dropdown arrow, only on single select (not multiple)
    'bg-arrow-drop-down-dark bg-no-repeat bg-[center_right_1rem]': !multiple,
    // Full Width
    'w-full': fullWidth,
    // Arrow down
    // 'bg-arrow-drop-down-dark  ': true,
    // Error
    'border !border-error text-error': error,
    // Padding
    'py-3 px-[10px] h-[50px]': padding === 'large',
    'px-4 py-3 h-[48px]': padding === 'medium',
    'px-3 py-2': padding === ''
  })
}

export const generateErrorClassnames = (props: any) => {
  const { variation } = props

  return classNames({
    'absolute top-full w-max flex flex-row font-sansPro items-center text-error text-xs font-semibold left-0 leading-4 xl:-mb-[6px] before:content-[""] before:bg-icon-warning-outline before:bg-center before:bg-contain before:bg-no-repeat before:w-4 before:h-4 before:block before:mr-2':
      variation === 'default',
    'absolute top-full w-max flex flex-row font-sansPro items-center text-white text-xs font-semibold left-0 leading-4 xl:-mb-[6px] before:content-[""] before:bg-icon-warning-outline-inverse before:bg-center before:bg-contain before:bg-no-repeat before:w-4 before:h-4 before:block before:mr-2':
      variation === 'inverse'
  })
}

export const SelectInput2Class = {
  generateSelectClassnames,
  generateErrorClassnames
}
